export class FilterComponent {
    constructor() {
        this.filterToggle = document.querySelectorAll('[data-toggle="active-filters"]');
        this.expandToggle = document.querySelectorAll('[data-toggle="expand-filters"]')
        this.filtersElement = document.querySelector('.filters')
        this.resultsElement = document.querySelector('.results')
        this.filtroDefault = document.querySelector('.filters-default')
        this.filtroOfertas = document.querySelector('.filters-ofertas')
        this.init()
    }

    init() {
        if(this.filterToggle) {
            Array.prototype.forEach.call(this.filterToggle, el => {
                el.addEventListener('click', e => {
                    const filtro = document.querySelector('.filters__order--mobile-icon')
                    if (filtro != null && filtro != 'undefined') {
                        document.querySelector('.filters__order--mobile-icon').classList.toggle('filters__order--mobile-icon--actived')
                    } else {
                        document.querySelector('.filter-icon').classList.toggle('filter-icon--actived')
                    }

                    document.body.classList.toggle('block-scroll-filters');
                    this.filtersElement.classList.toggle('filters--actived')
                    this.resultsElement.classList.toggle('results--reduced')
                    if (this.filtroDefault && this.filtroOfertas) {
                        this.filtroDefault.style.display = 'block'
                        this.filtroOfertas.style.display = 'none'
                    }
                })
            })
        }
        if(this.expandToggle) {
            Array.prototype.forEach.call(this.expandToggle, el => {
                el.addEventListener('click', e => {
                    el.querySelector('.plus-icon').classList.toggle('plus-icon--actived')
                    el.previousElementSibling.classList.toggle('filters__category-content--actived')
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/filters.js